import { DividerProps } from 'antd/lib/divider';

import { StyledDivider } from './styles';

export function UiDivider(props: DividerProps) {
  return <StyledDivider {...props} />;
}
